{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Пребаци оператеру",
    "MESSAGE": "Пребаци ме оператеру"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Preuzimanje",
      "UPLOADING": "Dodavanje..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Pošalji"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Ponovo pošalji poruku",
      "ERROR_MESSAGE": "Slanje neuspešno, pokušajte ponovo"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Ocenite kvalitet ovog odgovora"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Молимо сачекајте да се придружи агент"
  },
  "ROBOT_CHECK": {
    "TITLE": "Brza sigurnosna provera",
    "DESCRIPTION": "Molimo dovršite proveru ispod.",
    "VERIFYING": "Provera u toku…",
    "ERROR": "Ovo nije uspelo. Molimo pokušajte ponovo.",
    "RETRY": "Pokušaj ponovo"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Dostupni smo",
    "OFFLINE": "Trenutno nismo dostupni",
    "ONLINE_WITH_BOT": "Tim i naš AI asistent su na mreži",
    "OFFLINE_WITH_BOT": "Naš AI asistent je ovde da pomogne",
    "BOT_ONLY_REPLY": "Odgovara odmah"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Obično odgovaramo u roku od nekoliko minuta",
    "IN_A_FEW_HOURS": "Obično odgovaramo u roku od nekoliko sati",
    "IN_A_DAY": "Obično odgovaramo u roku od jednog dana",
    "BACK_IN": "Ponovo ćemo biti dostupni"
  },
  "DAY_NAMES": {
    "SUNDAY": "Nedelja",
    "MONDAY": "Ponedeljak",
    "TUESDAY": "Utorak",
    "WEDNESDAY": "Sreda",
    "THURSDAY": "Četvrtak",
    "FRIDAY": "Petak",
    "SATURDAY": "Subota"
  },
  "START_CONVERSATION": "Započnite razgovor",
  "END_CONVERSATION": "Završi razgovor",
  "CONTINUE_CONVERSATION": "Nastavi razgovor",
  "YOU": "Vi",
  "START_NEW_CONVERSATION": "Započnite novi razgovor",
  "RESOLVE_LATER": "Ову тему ћемо решити преко имејла/телефона. Сада желим да питам нешто друго.",
  "VIEW_UNREAD_MESSAGES": "Imate nepročitane poruke",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Pogledajte nove poruke",
    "CLOSE_MESSAGES_BUTTON": "Zatvori",
    "COMPANY_FROM": "od",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Razgovarajte sa nama"
  },
  "POWERED_BY": "Pokreće {brandName}",
  "EMAIL_PLACEHOLDER": "Molimo unesite vašu e-mail adresu",
  "CHAT_PLACEHOLDER": "Napišite vašu poruku",
  "TODAY": "Danas",
  "YESTERDAY": "Juče",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Puno ime",
        "PLACEHOLDER": "Molimo unesite vaše puno ime",
        "REQUIRED_ERROR": "Puno ime je obavezno"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "E-mail adresa",
        "PLACEHOLDER": "Molimo unesite vašu e-mail adresu",
        "REQUIRED_ERROR": "Adresa e-pošte je obavezna",
        "VALID_ERROR": "Molim vas unesite ispravnu adresu e-pošte"
      },
      "PHONE_NUMBER": {
        "LABEL": "Broj telefona",
        "PLACEHOLDER": "Molim vas unesite vaš broj telefona",
        "REQUIRED_ERROR": "Broj telefona je obavezan",
        "DIAL_CODE_VALID_ERROR": "Molimo izaberite pozivni broj države",
        "VALID_ERROR": "Molimo unesite ispravan broj telefona",
        "DROPDOWN_EMPTY": "Ništa nije pronađeno",
        "DROPDOWN_SEARCH": "Pretražite države"
      },
      "MESSAGE": {
        "LABEL": "Poruka",
        "PLACEHOLDER": "Molimo unesite vašu poruku",
        "ERROR": "Poruka prekratka"
      }
    },
    "CAMPAIGN_HEADER": "Molim vas dostavite vaše ime i e-poštu pre započinjanja razgovora",
    "IS_REQUIRED": "je obavezno",
    "REQUIRED": "Obavezno",
    "REGEX_ERROR": "Molimo unesite ispravnu vrednost"
  },
  "FILE_SIZE_LIMIT": "Datoteka prevazilazi {MAXIMUM_FILE_UPLOAD_SIZE} ograničenje priloga",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Neispravno polje"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Pretražite emodžije",
    "NOT_FOUND": "Nijedan emodži ne odgovara vašoj pretrazi",
    "ARIA_LABEL": "Izbor emodžija"
  },
  "CSAT": {
    "TITLE": "Ocenite razgovor",
    "SUBMITTED_TITLE": "Hvala vam na dostavljenoj oceni",
    "PLACEHOLDER": "Pričajte nam više..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Zatražite kopiju razgovora",
    "SEND_EMAIL_SUCCESS": "Transkript razgovora je uspešno poslat",
    "SEND_EMAIL_ERROR": "Pojavila se greška, molim vas pokušajte ponovo"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Popularni članci",
    "VIEW_ALL_ARTICLES": "Prikaži sve članke",
    "IFRAME_LOAD_ERROR": "Došlo je do greške pri učitavanju članka. Osvežite stranicu i pokušajte ponovo."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Otvori",
      "BUY": "Kupi"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Slikovita poruka"
    },
    "audio": {
      "CONTENT": "Govorna poruka"
    },
    "video": {
      "CONTENT": "Video poruka"
    },
    "file": {
      "CONTENT": "Prilog"
    },
    "location": {
      "CONTENT": "Lokacija"
    },
    "fallback": {
      "CONTENT": "je podelio link"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Odgovor na:"
  }
}
